/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../button/button.ngfactory';
import * as import2 from 'ionic-angular/components/button/button';
import * as import3 from 'ionic-angular/config/config';
import * as import4 from '@angular/common';
import * as import5 from '@angular/forms';
import * as import6 from 'ionic-angular/components/alert/alert-component';
import * as import7 from 'ionic-angular/components/backdrop/backdrop';
import * as import8 from 'ionic-angular/navigation/view-controller';
import * as import9 from 'ionic-angular/gestures/gesture-controller';
import * as import10 from 'ionic-angular/navigation/nav-params';
import * as import11 from 'ionic-angular/platform/platform';
const styles_AlertCmp:any[] = ([] as any[]);
export const RenderType_AlertCmp:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_AlertCmp,
  data: {}
}
);
function View_AlertCmp_1(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'h2',[[
        'class',
        'alert-title'
      ]
    ],[
      [
        8,
        'id',
        0
      ]
      ,
      [
        8,
        'innerHTML',
        1
      ]

    ]
  ,(null as any),(null as any),(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',co.hdrId,'');
    const currVal_1:any = co.d.title;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_AlertCmp_2(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'h3',[[
        'class',
        'alert-sub-title'
      ]
    ],[
      [
        8,
        'id',
        0
      ]
      ,
      [
        8,
        'innerHTML',
        1
      ]

    ]
  ,(null as any),(null as any),(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',co.subHdrId,'');
    const currVal_1:any = co.d.subTitle;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_AlertCmp_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'button',[
      [
        'class',
        'alert-tappable alert-radio'
      ]
      ,
      [
        'ion-button',
        'alert-radio-button'
      ]
      ,
      [
        'role',
        'radio'
      ]

    ]
    ,[
      [
        1,
        'aria-checked',
        0
      ]
      ,
      [
        8,
        'disabled',
        0
      ]
      ,
      [
        1,
        'id',
        0
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.rbClick(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_Button_0,import1.RenderType_Button)),
    import0.ɵdid(1097728,(null as any),0,import2.Button,[
      [
        8,
        'alert-radio-button'
      ]
      ,
      import3.Config,
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any)),
      (l()(),import0.ɵeld(0,(null as any),0,1,'div',[[
        'class',
        'alert-radio-icon'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'alert-radio-inner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),0,1,'div',[[
        'class',
        'alert-radio-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.checked;
    const currVal_1:any = v.context.$implicit.disabled;
    const currVal_2:any = v.context.$implicit.id;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = v.context.$implicit.label;
    ck(v,5,0,currVal_3);
  });
}
function View_AlertCmp_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[
      [
        'class',
        'alert-radio-group'
      ]
      ,
      [
        'role',
        'radiogroup'
      ]

    ]
    ,[
      [
        1,
        'aria-labelledby',
        0
      ]
      ,
      [
        1,
        'aria-activedescendant',
        0
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertCmp_5)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.d.inputs;
    ck(v,2,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.hdrId;
    const currVal_1:any = co.activeId;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_AlertCmp_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'button',[
      [
        'class',
        'alert-tappable alert-checkbox'
      ]
      ,
      [
        'ion-button',
        'alert-checkbox-button'
      ]
      ,
      [
        'role',
        'checkbox'
      ]

    ]
    ,[
      [
        1,
        'aria-checked',
        0
      ]
      ,
      [
        1,
        'id',
        0
      ]
      ,
      [
        8,
        'disabled',
        0
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.cbClick(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_Button_0,import1.RenderType_Button)),
    import0.ɵdid(1097728,(null as any),0,import2.Button,[
      [
        8,
        'alert-checkbox-button'
      ]
      ,
      import3.Config,
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any)),
      (l()(),import0.ɵeld(0,(null as any),0,1,'div',[[
        'class',
        'alert-checkbox-icon'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'alert-checkbox-inner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),0,1,'div',[[
        'class',
        'alert-checkbox-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.checked;
    const currVal_1:any = v.context.$implicit.id;
    const currVal_2:any = v.context.$implicit.disabled;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = v.context.$implicit.label;
    ck(v,5,0,currVal_3);
  });
}
function View_AlertCmp_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'alert-checkbox-group'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertCmp_7)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.d.inputs;
    ck(v,2,0,currVal_0);
  },(null as any));
}
function View_AlertCmp_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'alert-input-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'input',[
      [
        'class',
        'alert-input'
      ]
      ,
      [
        'dir',
        'auto'
      ]

    ]
    ,[
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        8,
        'type',
        0
      ]
      ,
      [
        8,
        'min',
        0
      ]
      ,
      [
        8,
        'max',
        0
      ]
      ,
      [
        1,
        'id',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,2)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,2).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,2)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,2)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(v.context.$implicit.value = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import5.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import5.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import5.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import5.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import5.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import5.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      isDisabled: [
        0,
        'isDisabled'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import5.NgControl,(null as any),[import5.NgModel]),
    import0.ɵdid(16384,(null as any),0,import5.NgControlStatus,[import5.NgControl],(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_12:any = v.context.$implicit.disabled;
    const currVal_13:any = v.context.$implicit.value;
    ck(v,4,0,currVal_12,currVal_13);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.placeholder;
    const currVal_1:any = v.context.$implicit.type;
    const currVal_2:any = v.context.$implicit.min;
    const currVal_3:any = v.context.$implicit.max;
    const currVal_4:any = v.context.$implicit.id;
    const currVal_5:any = import0.ɵnov(v,6).ngClassUntouched;
    const currVal_6:any = import0.ɵnov(v,6).ngClassTouched;
    const currVal_7:any = import0.ɵnov(v,6).ngClassPristine;
    const currVal_8:any = import0.ɵnov(v,6).ngClassDirty;
    const currVal_9:any = import0.ɵnov(v,6).ngClassValid;
    const currVal_10:any = import0.ɵnov(v,6).ngClassInvalid;
    const currVal_11:any = import0.ɵnov(v,6).ngClassPending;
    ck(v,1,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11
    ]
    );
  });
}
function View_AlertCmp_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'alert-input-group'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertCmp_9)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.d.inputs;
    ck(v,2,0,currVal_0);
  },(null as any));
}
function View_AlertCmp_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(16384,(null as any),0,import4.NgSwitch,([] as any[]),{ngSwitch: [
        0,
        'ngSwitch'
      ]
    },(null as any)),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertCmp_4)),
    import0.ɵdid(278528,(null as any),0,import4.NgSwitchCase,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import4.NgSwitch
    ]
      ,{ngSwitchCase: [
        0,
        'ngSwitchCase'
      ]
    },(null as any)),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertCmp_6)),
    import0.ɵdid(278528,(null as any),0,import4.NgSwitchCase,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import4.NgSwitch
    ]
      ,{ngSwitchCase: [
        0,
        'ngSwitchCase'
      ]
    },(null as any)),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertCmp_8)),
    import0.ɵdid(16384,(null as any),0,import4.NgSwitchDefault,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import4.NgSwitch
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.inputType;
    ck(v,1,0,currVal_0);
    const currVal_1:any = 'radio';
    ck(v,3,0,currVal_1);
    const currVal_2:any = 'checkbox';
    ck(v,5,0,currVal_2);
  },(null as any));
}
function View_AlertCmp_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'button',[[
        'ion-button',
        'alert-button'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.btnClick(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_Button_0,import1.RenderType_Button)),
    import0.ɵdid(278528,(null as any),0,import4.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import0.ɵdid(1097728,(null as any),0,import2.Button,[
      [
        8,
        'alert-button'
      ]
      ,
      import3.Config,
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted(0,[
      '',
      ''
    ]
    ))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.cssClass;
    ck(v,1,0,currVal_0);
  },(ck,v) => {
    const currVal_1:any = v.context.$implicit.text;
    ck(v,3,0,currVal_1);
  });
}
export function View_AlertCmp_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-backdrop',[
      [
        'disable-activated',
        ''
      ]
      ,
      [
        'role',
        'presentation'
      ]
      ,
      [
        'tappable',
        ''
      ]

    ]
      ,[[
        2,
        'backdrop-no-tappable',
        (null as any)
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import6.AlertCmp = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.bdClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import7.Backdrop,[
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'alert-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'alert-head'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertCmp_1)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertCmp_2)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'alert-message'
      ]
    ],[
      [
        8,
        'id',
        0
      ]
      ,
      [
        8,
        'innerHTML',
        1
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertCmp_3)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'alert-button-group'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import4.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['alert-button-group-vertical']),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertCmp_10)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import6.AlertCmp = v.component;
    const currVal_1:any = co.d.title;
    ck(v,5,0,currVal_1);
    const currVal_2:any = co.d.subTitle;
    ck(v,7,0,currVal_2);
    const currVal_5:any = co.d.inputs.length;
    ck(v,10,0,currVal_5);
    const currVal_6:any = 'alert-button-group';
    const currVal_7:any = ck(v,13,0,(co.d.buttons.length > 2));
    ck(v,12,0,currVal_6,currVal_7);
    const currVal_8:any = co.d.buttons;
    ck(v,15,0,currVal_8);
  },(ck,v) => {
    var co:import6.AlertCmp = v.component;
    const currVal_0:boolean = !co.d.enableBackdropDismiss;
    ck(v,0,0,currVal_0);
    const currVal_3:any = import0.ɵinlineInterpolate(1,'',co.msgId,'');
    const currVal_4:any = co.d.message;
    ck(v,8,0,currVal_3,currVal_4);
  });
}
function View_AlertCmp_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-alert',[[
        'role',
        'dialog'
      ]
    ],[
      [
        1,
        'aria-labelledby',
        0
      ]
      ,
      [
        1,
        'aria-describedby',
        0
      ]

    ]
      ,[[
        'body',
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('body:keyup' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).keyUp($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_AlertCmp_0,RenderType_AlertCmp)),
    import0.ɵdid(180224,(null as any),0,import6.AlertCmp,[
      import8.ViewController,
      import0.ElementRef,
      import3.Config,
      import9.GestureController,
      import10.NavParams,
      import0.Renderer,
      import11.Platform
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).hdrId;
    const currVal_1:any = import0.ɵnov(v,1).descId;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
export const AlertCmpNgFactory:import0.ComponentFactory<import6.AlertCmp> = import0.ɵccf('ion-alert',import6.AlertCmp,View_AlertCmp_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/alert/alert-component.ngfactory.ts